<template>
  <div>
    <v-list
      :heading="$t('brandList.heading')"
      :leaving-route="leavingRoute"
      :items="items"
    />
    <v-button
      secondary
      class="btn-used-car"
      @click="goToSolutions"
    >
      {{ $t("brandList.usedCar") }}
    </v-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import vList from "../components/vList";
import api from "../mixins/apiMixin.js";
import VButton from "../components/vButton";

export default {
  name: "VBrandList",
  components: {
    VButton,
    vList
  },
  mixins: [
    api.apiMixin
  ],
  data: function () {
    return {
      leavingRoute: false,
      items: [],
      loaded: false
    };
  },
  computed: {
    ...mapGetters([
      'getHttp'
    ])
  },

  methods: {
    ...mapActions(['updateField']),

    pushResponse(response) {
      var brands = response.data.data;

      this.items = [];

      if (brands.length === 1) {
        this.$router.push("/cars/" + brands[0].slug);
      } else {
        for (var index in brands) {
          this.items.push(this.transformItem(brands[index]));
        }
      }
      this.loaded = true;
    },

    transformItem(item) {
      var that = this;
      return {
        title: item.name,
        imageUrl: item.imageUrl,
        buttonLabelDefault: this.$t('brandList.button.label'),
        onClick: function () {
          that.updateField({
            store: "customer",
            key: "carBrand",
            value: { label: item.name, value: item.slug }
          });
          that.leavingRoute = true;
          //        setTimeout(function(){
          that.$router.push("/cars/" + item.slug);
          //       }, 200)
        }
      };
    },
    goToSolutions () {
      this.$router.push("/solutions");
    }
  },
  mounted: function () {
    var that = this;

    const http = this.getHttp;
    let config = this.apiHeaders;

    // then do the real request
    http.get(process.env.VUE_APP_API_URL + "/cars", config).then(function (response) {
      that.pushResponse(response);
    }).catch(function (error) {

      // todo: generically handle this
      if (error.response.status == 401) {
        that.logout();
      }
      console.log(error);
    });

    // then do the real request
    config.forceUpdate = true;
    http.get(process.env.VUE_APP_API_URL + "/cars", config).then(function (response) {
      that.pushResponse(response);
    }).catch(function (error) {
      if (error.response.status == 401) {
        that.logout();
      }
        //eslint-disable-next-line no-console
      console.log(error);
    });
  }
};
</script>

<style scoped lang="scss">
.btn-used-car {
  margin: 0 auto;
}
</style>
